module.exports = __webpack_public_path__ + "static/media/evolutionapi.3f3d5c3d.svg";